import { styled } from "@mui/material";

export const SwimlaneObserver = styled("div")(() => ({
  display: "hidden",
}));
